function Footer(props) {

  return (


<footer id="footer" className="footer footer-dark">
  <div className="container">
    <div className="columns">
      <div className="column">
        <div className="footer-logo">
          <img id="footer-logo" src="CanuckzNFT-logo-stacked.png" alt="Footer logo" />
        </div>
      </div>
        <div className="column">
          <div className="footer-column">
            <div className="footer-header mb-3">
                <h3>Navigation</h3>
            </div>
            <ul className="link-list">
              <li>
                <a href="https://canuckz-nft.io/" className="is-white">
                  Home
                </a>
              </li>
              <li>
                <a href="https://canuckz-nft.io/about">
                  About
                </a>
              </li>
              <li>
                <a href="https://canuckz-nft.io/buy">
                  Buy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="column">
          <div className="footer-column">
            <div className="footer-header">
                <h3>Partners</h3>
            </div>
            <ul className="link-list">
              <li>
                <a href="https://cardanocanucks.com">
                  Cardano Canucks
                </a>
              </li>
              <li>
                <a href="https://oraclecharli3.medium.com/charli3s-first-nft-platform-collaboration-with-canuckz-nfts-44c4f2e49912">
                  Charli3
                </a>
              </li>
            </ul>
          </div>
        </div>
      <div className="column">
        <div className="footer-column">
          <div className="footer-header">
            <h3>Follow Us</h3>
            <nav className="level is-mobile mt-3">
              <div className="level-left">
                <a className="level-item" href="https://t.me/CanuckzNFT">
                  <span className="icon"><i className="fab fa-telegram" aria-hidden="true"></i></span>
                </a>
                <a className="level-item" href="https://discord.gg/e8M5GHpycZ">
                  <span className="icon"><i className="fab fa-discord" aria-hidden="true"></i></span>
                </a>
                <a className="level-item" href="https://twitter.com/CanuckzNFT">
                  <span className="icon"><i className="fab fa-twitter" aria-hidden="true"></i></span>
                </a>
                {/* <a className="level-item"
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    props.handleDebugClick()
                  }}
                 style={{position:'absolute', right: 0, bottom: 0, color: "white"}}
                 >
                  <span className="icon"><i className="fab fa-buffer" aria-hidden="true"></i></span>
                </a> */}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>




  );
}

export default Footer;